export const YouTubeIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 72 72"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FF0002"
        d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36Z"
      />
      <path
        fill="#FFF"
        d="m31.044 42.27-.002-13.582 12.97 6.814-12.968 6.768ZM59.52 26.334s-.47-3.33-1.908-4.798c-1.826-1.926-3.872-1.935-4.809-2.047C46.086 19 36.011 19 36.011 19h-.022s-10.075 0-16.792.49c-.939.111-2.983.12-4.81 2.046-1.439 1.467-1.907 4.798-1.907 4.798S12 30.247 12 34.158v3.668c0 3.912.48 7.823.48 7.823s.468 3.331 1.906 4.798c1.828 1.926 4.226 1.866 5.294 2.067C23.52 52.885 36 53 36 53s10.086-.015 16.803-.505c.938-.113 2.983-.122 4.809-2.048 1.438-1.467 1.908-4.798 1.908-4.798s.48-3.91.48-7.823v-3.668c0-3.911-.48-7.824-.48-7.824Z"
      />
    </g>
  </svg>
);
